import { render, staticRenderFns } from "./common-body.vue?vue&type=template&id=20a07d34"
import script from "./common-body.vue?vue&type=script&lang=js"
export * from "./common-body.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/common-shell.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports